import AnalyticsEvents_V2 from '~/analytics/analyticsGA4'
import { PortalProducts } from '~/analytics/types/analytics.type'

class TestPrepAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.TEST_PREP)
  }
}

const testPrepAnalytics = new TestPrepAnalytics()

export default testPrepAnalytics
